import React from 'react'
import { ChildrenProps } from "../../modules/types"
import './ButtonBase.css'
import './Colors.css'

export enum ButtonType {
  Primary,
  Secondary
}

export enum ButtonSize {
  Mini = 0,
  Small = 1,
  Medium = 2,
  Large = 3
}

function getButtonSizeClass(size: ButtonSize) {
  switch (size) {
    case ButtonSize.Mini: {
      return 'button-mini'
    }

    case ButtonSize.Small: {
      return 'button-small'
    }

    case ButtonSize.Medium: {
      return 'button-medium'
    }

    case ButtonSize.Large: {
      return 'button-large'
    }
  }
}

function getButtonTypeClass(type: ButtonType) {
  switch (type) {
    case ButtonType.Primary: {
      return 'button-primary'
    }

    case ButtonType.Secondary: {
      return 'button-secondary'
    }
  }
}

function ButtonBase(props: ChildrenProps) {
  const { children, size, icon, secondaryIcon, className, type, ...rest } = props

  if (icon && secondaryIcon && !children) {
    throw new Error('If both primary and secondary icons are specified, the button must also have text.')
  }

  if (secondaryIcon && !children && !icon) {
    throw new Error('Invalid parameter combination. Use prop "icon" instead of "secondaryIcon".')
  }

  return (
    <button className={`${getButtonTypeClass(type)} ${getButtonSizeClass(size)} ${className}`} {...rest}>
      {icon && (
        <>
          <i className={icon}></i>
          {icon && children && (
            <span>&nbsp;</span>
          )}
        </>
      )}

      {children}

      {secondaryIcon && (
        <>
          &nbsp;<i className={secondaryIcon}></i>
        </>
      )}
    </button>
  )
}

export default ButtonBase
